// SessionDashboard.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import style from './SessionDashboard.module.css';

const formatTime = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const rawMinutes = totalMinutes % 60;
  const minutes = Math.round(rawMinutes);

  return `${hours}h ${minutes}m`;
};

const SessionDashboard = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSellersWithSessions = async () => {
      try {
        const res = await axios.get('/sellers/active-with-sessions');
        setSellers(res.data);
      } catch (error) {
        console.error('Error al obtener los agentes:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSellersWithSessions();
  }, []);

  return (
    <div className={style.container}>
      <h2 className={style.title}>Actividad de Agentes</h2>
      {loading ? (
        <p className={style.loading}>Cargando...</p>
      ) : (
        <div className={style.tableWrapper}>
          <table className={style.table}>
            <thead>
              <tr>
                <th>Foto</th>
                <th>Agente</th>
                <th>Email</th>
                <th>Tipo</th>
                <th>Rango</th>
                <th>Sesiones</th>
                <th>Tiempo acumulado</th>
              </tr>
            </thead>
            <tbody>
              {sellers.map(seller => (
                <tr key={seller.id}>
                  <td>
                    <img
                      src={seller.photo}
                      alt={seller.name}
                      className={style.avatar}
                    />
                  </td>
                  <td>
                    <Link to={`/dashboard-sesiones/${seller.id}`} className={style.agentLink}>
                      {seller.name} {seller.last_name}
                    </Link>
                  </td>
                  <td>{seller.mail}</td>
                  <td>{seller.type}</td>
                  <td>{seller.rank}</td>
                  <td>{seller.sessionCount}</td>
                  <td>{formatTime(seller.totalMinutes)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SessionDashboard;